import { AxiosError } from 'axios';
import i18next from 'i18next';

import { StatusCode } from 'enums';

const getErrorMessage = (
  error: AxiosError<{ message: string | undefined }>,
) => {
  const status = error?.response?.status;
  const messageArrayItem = error.response?.data?.message?.[0] as any;
  if (status === StatusCode.BadRequest) {
    const message = error.response?.data?.message;
    if (message === 'Unable to create new account: no platform wallet') {
      return i18next.t('create_wallet.no_platform_wallet');
    } else if (message === 'Unable to create new account: transaction error') {
      return i18next.t('create_wallet.transaction_error');
    } else if (
      messageArrayItem?.constraints?.too_often &&
      messageArrayItem?.property === 'createdAt'
    ) {
      return i18next.t('create_wallet.create_too_often');
    }
  }
};

export const walletsUtils = {
  getErrorMessage,
};
